module.exports = __webpack_public_path__ + "static/media/FANTOM.38278073.svg";